import { Component } from "react";

class MaintenancePage extends Component<unknown, unknown> {
  public render() {
    const home = process.env.NODE_ENV === "development"
      ? "/app/v2.0"
      : "/";

    return (
      <div>
        <header className="app-header app-header-dark">
          <div className="top-bar">
            <div className="top-bar-brand">
              <a href={home}>
                <img id="logo" src={`${window.customUIBaseUrl}/images/QUA_Logo_Green_White.png`} alt="Quest Analytics" style={{ height: "52px", width: "auto" }} />
              </a>
            </div>
          </div>
        </header>

        <div className="empty-state">
          <div className="empty-state-container">
            <div className="card border border-secondary mt-5">
              <div className="card-body">
                <div className="state-figure">
                  <img className="img-fluid w-75" src="/images/maintenance.png" />
                </div>
                <h3 className="state-header"> We&apos;re working on some updates </h3>
                <p className="state-description"> We apologize for any inconvenience, but we&apos;ll be back up in no time. Check back soon! </p>
              </div>
            </div>

            <p className="text-muted small">Illustration by Stories by <a className="text-muted" href="https://stories.freepik.com/">Freepik</a></p>
          </div>
        </div>
      </div>
    );
  }
}

export { MaintenancePage };
